import { faArrowRight } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import "./style.scss";

interface CompanyCardProps {
    item: any;
    onSelect: () => void;
}

const CompanyCard = (props: CompanyCardProps) => {
    return (
        <div className="bis-company-card-root">
            <div className="bis-company-card-data">
                <div className="bis-company-card-data-name">
                    <div>{props.item.name}</div>
                    <div>{props.item.address}</div>
                </div>
                <div className="bis-company-card-data-vatNumber">
                    <FormattedMessage id="widgets.companyCard.vatNumber" />{" "}
                    <span>{props.item.piva}</span>
                </div>
                <div className="bis-company-card-data-fiscalCode">
                    <FormattedMessage id="widgets.companyCard.fiscalCode" />{" "}
                    <span>{props.item.fiscal_code}</span>
                </div>
                <div className="bis-company-card-data-rea">
                    <FormattedMessage id="widgets.companyCard.rea" />{" "}
                    <span>{props.item.rea}</span>
                </div>
            </div>
            <div className="bis-company-card-select">
                <FontAwesomeIcon
                    onClick={() => props.onSelect()}
                    icon={faArrowRight}
                />
            </div>
        </div>
    );
};

export default CompanyCard;
